import { EmptyCaseIconWithDescription } from '~/@pages/@common/EmptyCase'

export const EmptyCaseInChallenge = () => (
  <EmptyCaseIconWithDescription>
    <p>챌린지가 준비되지 않았어요</p>
  </EmptyCaseIconWithDescription>
)
